import React from 'react'
import { useLangContext } from 'services/contexts/LangContext'
import { parseMultilang } from 'services/utils/multilangParseWrite'

type Props = {
  children: string
  style?: React.CSSProperties
}

const LocalizedSpan: React.FC<Props> = ({ children, style }) => {
  const { currentLang } = useLangContext()
  return <span style={style}>{parseMultilang(currentLang)(children)}</span>
}

export default LocalizedSpan
